import { render, staticRenderFns } from "./AccountsDetails.vue?vue&type=template&id=4680d77e&"
import script from "./AccountsDetails.vue?vue&type=script&lang=js&"
export * from "./AccountsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports